import withStep from '@/containers/withStep';

import DefaultWhatsNext from './variants/DefaultWhatsNext';

export const VARIANTS = [DefaultWhatsNext];

export const WhatsNext = withStep('WhatsNext', {
  id: 'whats-next',
  description: "What's next page, the hub for the merchant",
  variants: VARIANTS,
});
